// @LogOut
function LogOut() {
  sessionStorage.clear();
  window.location.href="/login"
}
export default LogOut;
      